import { FlexContainer } from '@emarketer/componentlibrary';
import styled from 'styled-components';
import { COLOR } from '../../theme/constants';

export const FiltersWrapper = styled(FlexContainer)`
  .popper-tooltip {
    z-index: 1000;
    border: 1px solid ${COLOR.LIGHTGREY};
    border-radius: 6px;
    box-shadow: none;
    filter: drop-shadow(0px 4px 8px rgba(17, 17, 17, 0.1));

    @keyframes fadeIn {
      from {
        opacity: 0;
        top: -5px;
      }
      to {
        opacity: 1;
        top: 0;
      }
    }

    animation: fadeIn 0.5s forwards;
  }
`;
